import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TutorialState {
  hasCompletedAnalysisTutorial: boolean;
  hasCompletedFilesTutorial: boolean;
}

const initialState: TutorialState = {
  hasCompletedAnalysisTutorial: false,
  hasCompletedFilesTutorial: false,
};

const tutorialSlice = createSlice({
  name: 'tutorial',
  initialState,
  reducers: {
    setHasCompletedAnalysisTutorial: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.hasCompletedAnalysisTutorial = action.payload;
    },
    setHasCompletedFilesTutorial: (state, action: PayloadAction<boolean>) => {
      state.hasCompletedFilesTutorial = action.payload;
    },
  },
});

export const { setHasCompletedAnalysisTutorial, setHasCompletedFilesTutorial } =
  tutorialSlice.actions;
export default tutorialSlice.reducer;
